import React, {useEffect, useState} from 'react';
import {
    CardTitle, Button
} from 'reactstrap';
import Parametri from '../../parametri';
import VisualizzaAllegato from '../VisualizzaAllegato';
import TrasformaDateAUmano from '../TrasformaDateAUmano';
import Clessidra from '../Clessidra';

function SchedaVerificheUploadUtenti(props) {

    const [documento, setDocumento] = useState(null);
    const [caricamento, setCaricamento] = useState(true);
    const [operazioneInCorso, setOperazioneInCorso] = useState(false);
    const [idIgnorati, setIdIgnorati] = useState([]);

    function caricaProssimo(ignorati = idIgnorati) {

        setCaricamento(true);
        setDocumento(null);

        fetch(Parametri("serverURL",props.identitaSelezionata), {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                op: "verificaUploadUtenteProssimo",
                tipo: props.tipo,
                idIgnorati: ignorati,
                emak: props.emak,
                sessionId:props.sessionId
                })
        })
        .then(risposta => risposta.json())
        .then(
            valoreDiRitorno => {

                setCaricamento(false);

                if (valoreDiRitorno.risultatoOperazione !== 1) {
                    window.alert(
                        valoreDiRitorno.mess !== undefined
                            ? valoreDiRitorno.mess
                            : "Errore durante il recupero del documento"
                    );
                    return;
                }

                /*
                 * risultatoRitorno:
                 *
                 * null = non ci sono altri documenti da verificare
                 *
                 * oppure:
                 *
                 * {
                 *     ID: ...,
                 *     NOME: ...,
                 *     COGNOME: ...,
                 *     DATA: ...,
                 *     FILE: ...,
                 *     TYPE_FILE: ...,
                 *     ESTENSIONE_FILE: ...
                 * }
                 */

                if (
                    valoreDiRitorno.risultatoRitorno === null ||
                    valoreDiRitorno.risultatoRitorno === undefined
                ) {
                    setDocumento(null);
                    return;
                }

                setDocumento(valoreDiRitorno.risultatoRitorno);
            },
            () => {
                setCaricamento(false);
                window.alert("Errore di connessione");
            }
        );
    }

    function eseguiAzione(azione) {

        if (!documento || operazioneInCorso) return;

        setOperazioneInCorso(true);

        fetch(Parametri("serverURL",props.identitaSelezionata), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                op: "verificaUploadUtente",
                tipo: props.tipo,
                azione: azione,
                idPersona: documento.ID,
                emak: props.emak,
                sessionId:props.sessionId
            })
        })
        .then(risposta => risposta.json())
        .then(
            valoreDiRitorno => {

                setOperazioneInCorso(false);

                if (valoreDiRitorno.risultatoOperazione !== 1) {
                    window.alert(
                        valoreDiRitorno.mess !== undefined
                            ? valoreDiRitorno.mess
                            : "Errore durante l'operazione"
                    );
                    return;
                }

                caricaProssimo();
            },
            () => {
                setOperazioneInCorso(false);
                window.alert("Errore di connessione");
            }
        );
    }

    function conferma() {

        eseguiAzione("conferma");
    }

    function elimina() {

        if (!documento || operazioneInCorso) return;

        if (!window.confirm(
            "Confermi l'eliminazione del documento?\n\n" +
            "Verranno eliminati l'allegato e la relativa data."
        )) {
            return;
        }

        eseguiAzione("elimina");
    }

    function ignora() {

        if (!documento) return;
        const nuoviIgnorati = [
                ...idIgnorati,
                documento.ID
        ];
        setIdIgnorati(nuoviIgnorati);
        caricaProssimo(nuoviIgnorati);
    }

    
    useEffect(() => {
        caricaProssimo();
    }, [props.tipo]);

    let titolo = "";

    if (props.tipo === "certificati") {
        titolo = "certificati medici";
    }

    if (props.tipo === "documentiId") {
        titolo = "documenti di identità";
    }

    if (caricamento) {
        return (
            <Clessidra loading={true} />
        );
    }

    return (
        <div
            className="schedaContenitore"
            style={{height: props.dimensioniApp.yMain}}
        >

            <div
                className="schedaSpazioCentrale"
                style={{height: props.dimensioniApp.yMain}}
            >

                <CardTitle>
                    Verifica&nbsp;{titolo}
                </CardTitle>

                {!documento ? (

                    <div
                        style={{
                            textAlign: "center",
                            marginTop: "30px"
                        }}
                    >
                        Nessun altro documento da verificare
                    </div>

                ) : (

                    <>

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: "15px"
                            }}
                        >
                            <div>
                                <b>
                                    {documento.COGNOME} {documento.NOME}
                                </b>
                            </div>

                            <div style={{marginTop: "8px"}}>
                                Data scadenza:&nbsp;
                                <b>
                                    <TrasformaDateAUmano data={documento.DATA || "non indicata"}/>
                                </b>
                            </div>
                        </div>

                        <VisualizzaAllegato
                            contenutoFile={documento.FILE || ""}
                            tipoFile={documento.TYPE_FILE || ""}
                            estensioneFile={documento.ESTENSIONE_FILE || ""}

                            cssContenitore="documentoVerificaContenitore"
                            cssImmagine="documentoVerificaImmagine"
                            cssPdf="documentoVerificaPdf"
                            cssTestoEstensione="documentoVerificaEstensione"

                            disabilitaCambio
                        />

                    </>

                )}

            </div>

            {documento && (

                <div className="schedaSpazioInferiore">

                    <Button
                        color="primary"
                        disabled={operazioneInCorso}
                        className="mt-2 bottoneMargineADestra"
                        onClick={() => conferma()}
                    >
                        Conferma
                    </Button>

                    <Button
                        color="danger"
                        disabled={operazioneInCorso}
                        className="mt-2 bottoneMargineADestra"
                        onClick={() => elimina()}
                    >
                        Elimina
                    </Button>

                    <Button
                        color="primary"
                        disabled={operazioneInCorso}
                        className="mt-2 bottoneMargineADestra"
                        onClick={() => ignora()}
                    >
                        Ignora
                    </Button>

                </div>

            )}

        </div>
    );
}

export default SchedaVerificheUploadUtenti;